import {createSelector} from '@reduxjs/toolkit'
import {
  getAnchorComplete,
  getHotelEntities,
  getHotelIdsToDisplay,
  getHotelOfferEntities,
  getIsSearchCompleted,
  getModuleState,
  getResolvedAnchorHotelId,
  getSearchParameters,
  getShowTotalPrices,
  getSplitBookingDetails
} from 'modules/sapiSearch/selectors'
import {getIsMultiRoomBundlesSearch} from 'modules/search/selectors'
import {getIsFromGha, getIsFromGVR} from 'utils/trafficSource'

/**
 * Select the main candidate pool and whether anchor pricing has finished for comparison.
 */
export const getSimilarHotelsInput = createSelector(
  [
    getResolvedAnchorHotelId,
    getHotelEntities,
    getHotelOfferEntities,
    getHotelIdsToDisplay,
    getAnchorComplete,
    getIsSearchCompleted,
    state =>
      getSplitBookingDetails(state, getResolvedAnchorHotelId(state))
        .showSplitBookingLoader
  ],
  (
    anchorId,
    hotels,
    offers,
    hotelIds,
    anchorComplete,
    searchComplete,
    showSplitBookingLoader
  ) => ({
    anchorOffersReady: Boolean(
      anchorComplete && searchComplete && !showSplitBookingLoader
    ),
    anchorId,
    firstResultId: hotelIds?.find(id => id !== anchorId),
    hotels: hotels ?? {},
    offers: offers ?? {}
  })
)

/**
 * Collect the search and display settings used to calculate prices consistently with the main hotel cards.
 */
export const getSimilarHotelsPricingContext = createSelector(
  [
    getModuleState,
    getResolvedAnchorHotelId,
    getSearchParameters,
    getIsFromGha,
    getIsFromGVR,
    getShowTotalPrices,
    getIsMultiRoomBundlesSearch
  ],
  (
    moduleState,
    anchorId,
    search,
    isFromGha,
    isFromGvr,
    showTotalPrices,
    isMultiRoomBundlesSearch
  ) => ({
    moduleState,
    anchorId,
    search,
    isFromGha,
    isFromGvr,
    showTotalPrices,
    isMultiRoomBundlesSearch
  })
)
